// extracted by mini-css-extract-plugin
export var parcelRow = "_t6-0";